import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class DebounceService {

    constructor() { }

    debounce(func: Function, delay: number): Function {
        let timer: any;
        return function (...args: any[]) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

}